module.exports = __webpack_public_path__ + "static/IMG_1187-c76f9df1bc0be7fb6d3da5498f5f7382.jpg";